import React, { useEffect } from 'react';
// import Head from 'next/head';

import { makeStyles, useTheme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Fade from 'react-reveal/Fade';

import FullRow from './ui/blocks/FullRow';
import LineBreak from './ui/blocks/LineBreak';

import imageHeader from '../assets/images/about/book.gif';

const useStyles = makeStyles(theme => ({
    missionStatement: {
        fontWeight: 300,
        fontSize: "1.5rem",
        maxWidth: "50em",
        lineHeight: "1.4"
    },
    rowContainer: {
        paddingLeft: "5em",
        paddingRight: "5em",
        overflowX: "hidden",
        [theme.breakpoints.down("sm")]: {
            paddingLeft: "1.5em",
            paddingRight: "1.5em",
        }
    },
    avatar: {
        height: "80%",
        width: "80%",

    },
    subtitle: {
        maxWidth: "550px",
        marginBottom: "1em"
    },
    icon: {
        marginLeft: "2em",
        maxWidth: "300px",
        [theme.breakpoints.down("xs")]: {
            marginLeft: 0
        }
    },
    serviceContainer: {
        marginTop: "12em",
        [theme.breakpoints.down("sm")]: {
            padding: 25,
            marginTop: "0em",
        }
    },
}))

export default function About(props) {
    const classes = useStyles();
    const theme = useTheme();
    const matchesSM = useMediaQuery(theme.breakpoints.down("sm"));

    const content = props.content.about;
    const language = props.language;
    const setValue = props.setValue;

    // const team = [
    //     { name: content.member1, position: content.position1, },
    //     { name: content.member2, position: content.position2, },
    //     { name: content.member3, position: content.position3, },
    //     { name: content.member4, position: content.position4, },
    // ];

    useEffect(() => {
        window.scrollTo(0, 0);
        setValue(2);
    }, [setValue]);

    const subtitleTxt1 = () => {
        let x = content.secondRow.subtitle1;
        const lines = x.split("\n");
        return (
            <div>
                {lines.map((line, index) => (
                    <Typography variant="subtitle1" className={classes.subtitle} style={{ textAlign: "justify", lineHeight: 1.5, marginBottom: "0.4em" }}
                        key={index} >
                        {line}
                    </Typography>))}
            </div>
        )
    }

    const subtitleTxt2 = () => {
        let x = content.secondRow.subtitle2;
        const lines = x.split("\n");
        return (
            <div>
                {lines.map((line, index) => (
                    <Typography variant="subtitle1" className={classes.subtitle} style={{ textAlign: "justify", lineHeight: 1.5, marginBottom: "0.4em" }}
                        key={index} >
                        {line}
                    </Typography>))}
            </div>
        )
    }

    return (
        <React.Fragment>
            {/* <Head>
                <title key="title">شبکه عصر دانش آرا</title>
                <meta name="description" key="description" content="شرکت شبکه عصر دانش آرا، ارائه دهنده خدمات اکتیو و پسیو شبکه و کامپیوتر" />
                <meta property="og:title" key="og:title" content="شرکت شبکه عصر دانش آرا، ارائه دهنده خدمات اکتیو و پسیو شبکه و کامپیوتر" />
            </Head> */}

            <Grid container direction="column" dir={language === "per" ? "rtl" : null} style={{ marginTop: matchesSM ? "-5em" : null }}>

                {/* Header */}
                {/* <Fade duration={1500} distance="0">
                    <Grid item className={classes.rowContainer} style={{ marginTop: matchesMD ? "1em" : "2em" }}>
                        <Typography variant="h2" align={matchesMD ? "center" : undefined} >{content.title}</Typography>
                    </Grid>
                    <Grid item container justify="center" className={classes.rowContainer} style={{ marginTop: "3em" }}>
                        <div >
                            {subtitleTxt()}
                        </div>
                    </Grid>
                </Fade> */}

                <FullRow content={content} image={imageHeader} language={language} dir={0} imageW={450} />

                {/* First row */}
                {/* <FullRow content={content.firstRow} language={language} dir={0} animeW={450} animeH={450} /> */}
                <LineBreak height="75px" type={0} />

                {/* Team */}
                {/* <Grid item container direction="column" alignItems="center" className={classes.rowContainer} style={{ marginTop: "5em", marginBottom: "10em" }}>

                    <Grid item style={{ marginBottom: "50px" }} >
                        <Typography variant="h4" gutterBottom align="center">{content.title2}</Typography>
                    </Grid>

                    <Grid item>
                        <Grid item container direction="row">
                            {team.map((member, index) => (
                                <Grid item md={3} sm={6} xs={12} key={`${member}${index}`}>
                                    <Grid item>
                                        <Typography variant="body1" paragraph align="center">
                                            {member.position}
                                        </Typography>
                                        <Typography variant="body1" paragraph align="center">
                                            {member.name}
                                        </Typography>
                                    </Grid>
                                    <Grid item container justify="center">
                                        <Avatar alt="founder" src="/assets/founder.jpg" className={classes.avatar} />
                                    </Grid>
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                </Grid >

                <LineBreak height="75px" type={1} /> */}

                {/* Second row */}
                <Grid container direction="row" justify="center" className={classes.rowContainer} style={{ marginTop: "5em", marginBottom: "5em" }}>


                    <Grid item container direction="column" alignItems={matchesSM ? "center" : undefined} md style={{ maxWidth: "40em" }}>
                        <Fade duration={1500} distance={matchesSM ? "0" : null} right >
                            <Grid item>
                                <Typography variant="h4" align={matchesSM ? "center" : undefined} >{content.secondRow.title1}</Typography>
                            </Grid>
                            <Grid item>
                                <div >
                                    {subtitleTxt1()}
                                </div>
                            </Grid>
                        </Fade>
                    </Grid>

                    <Grid item container direction="column" alignItems={matchesSM ? "center" : undefined} md style={{ maxWidth: "40em", marginTop: matchesSM ? "50px" : null }}>
                        <Fade duration={1500} distance={matchesSM ? "0" : null} left >
                            <Grid item>
                                <Typography variant="h4" align={matchesSM ? "center" : undefined} >{content.secondRow.title2}</Typography>
                            </Grid>
                            <Grid item>
                                <div >
                                    {subtitleTxt2()}
                                </div>
                            </Grid>
                        </Fade>
                    </Grid>

                </Grid>
            </Grid >

            <LineBreak height="75px" type={1} />

            <Grid item container justify="center" className={classes.rowContainer} style={{ marginTop: "5em", marginBottom: "5em" }}>
                <Typography variant="subtitle1" style={{ textAlign: "center", maxWidth: "550px", lineHeight: 1.5, marginBottom: "0.4em" }}>
                    امید است با توكل به خداوند متـعال و رضایت شما مشتریان ارجمند در ارائه و پشتـیبانی سیستمهای آن شركت علاوه بر دستیابی به اهداف فوق الذكر، خدمتی در جهت پیشرفت ف‍‍‍ناوری در ایران عزیز انجام داده باشیم
                </Typography>
            </Grid>

        </React.Fragment>
    )
}